import { useCallback, useEffect, useState } from "react";
import { playChime, unlockAudio } from "../lib/chime";

const KEY = "fora_sound";

export function useSound() {
  const [enabled, setEnabled] = useState(() => localStorage.getItem(KEY) !== "off");

  useEffect(() => {
    const unlock = () => unlockAudio();
    document.addEventListener("click", unlock);
    document.addEventListener("keydown", unlock);
    return () => {
      document.removeEventListener("click", unlock);
      document.removeEventListener("keydown", unlock);
    };
  }, []);

  const toggle = useCallback(() => {
    setEnabled((on) => {
      const next = !on;
      localStorage.setItem(KEY, next ? "on" : "off");
      if (next) playChime();
      return next;
    });
  }, []);

  const chime = useCallback(() => {
    if (enabled) playChime();
  }, [enabled]);

  return { enabled, toggle, chime };
}
